module.exports = __webpack_public_path__ + "img/211.89eb45bc.png";